import { join } from 'lodash'

export const title = (title: string[] = ['Qureos']): string =>
  join(title, ' • ')
